import { render, staticRenderFns } from "./NameInput.vue?vue&type=template&id=3538e442&scoped=true"
import script from "./NameInput.vue?vue&type=script&lang=ts"
export * from "./NameInput.vue?vue&type=script&lang=ts"
import style0 from "./NameInput.vue?vue&type=style&index=0&id=3538e442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3538e442",
  null
  
)

export default component.exports